import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthContext } from './hooks/useAuthContext';

//importing pages and components
import LandingPage from './pages/LandingPage';
import MainApp from './pages/MainApp';
import Home from './pages/Home';
import RequestsPage from './pages/RequestsPage';
import InventoryPage from './pages/InventoryPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import SaleOrdersPage from './pages/SaleOrdersPage';
import ReportsPage from './pages/ReportsPage';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Profile from './pages/Profile';
import ResetPasswordPage from './pages/ResetPasswordPage';

function App() {
  const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook


  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<LandingPage />}/>
          <Route path='/login' element={!user ? <Login /> : <Navigate to='/main/home' />} />
          <Route path='/reset-password' element={!user ? <ResetPasswordPage /> : <Navigate to='/main/home' />} />
          <Route path='/signup' element={<Signup />} />
          
          <Route path='/main' element={user ? <MainApp /> : <Navigate to='/login' />} >
              <Route 
                path='home'
                element={<Home />}
              />
              <Route 
                path='requests'
                element={<RequestsPage />}
              />
              <Route
                path='inventory'
                element={<InventoryPage />}
              />
              <Route 
                path='purchase-orders' 
                element={<PurchaseOrdersPage />}
              />
              <Route 
                path='sale-orders' 
                element={<SaleOrdersPage />} 
              />
              <Route 
                path='reports' 
                element={<ReportsPage />} 
              />
              <Route 
                path='profile' 
                element={<Profile />} 
              />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
